module.exports = __webpack_public_path__ + "static/media/Clemson.cc7ee04c.png";